// extracted by mini-css-extract-plugin
export default {"formLabel":"FieldItem_formLabel__K6LAg"};